module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.18.0@babel-runtime/core-js/object/define-property.js
// module id = 269
// module chunks = 2